import axios from "axios";
import SideNavbar from "../../../components/common/SideNavbar";
import TopNavbar from "../../../components/common/TopNavbar";
import { useEffect, useState, useCallback } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { userTableCustomStyles } from "../../../utils/TableCustomStyles";
import PlaceholderPicture from "../../../images/placeholder-profile.png";
import Select from "react-select";
import { smallFormSelectCustomStyles } from "../../../utils/SelectCustomStyles";

function UserMaster() {
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [dataPending, setDataPending] = useState(true);
  const [customerBranchData, setCustomerBranchData] = useState([]);
  const [userAgentData, setUserAgentData] = useState([]);
  const [branchDataPending, setBranchDataPending] = useState(false);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] =
    useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");

  // Canvas visibility
  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showUpdateCanvas, setShowUpdateCanvas] = useState(false);
  const [canvasAddFullScreen, setCanvasAddFullScreen] = useState(false);
  const [canvasUpdateFullScreen, setCanvasUpdateFullScreen] = useState(false);

  // Tabs for add
  const [showUserDetails, setShowUserDetails] = useState(true);
  const [showUserCustomerDetails, setShowUserCustomerDetails] = useState(false);
  const [showUserAgentDetails, setShowUserAgentDetails] = useState(false);

  // Tabs for update
  const [showUpdateUserDetails, setShowUpdateUserDetails] = useState(true);
  const [showUpdateUserCustomerDetails, setShowUpdateUserCustomerDetails] =
    useState(false);
  const [showUpdateUserAgentDetails, setShowUpdateUserAgentDetails] =
    useState(false);

  // Conditional tabs visibility
  const [showCustomerTab, setShowCustomerTab] = useState(false);
  const [showAgentTab, setShowAgentTab] = useState(false);
  const [showUpdateCustomerTab, setShowUpdateCustomerTab] = useState(false);
  const [showUpdateAgentTab, setShowUpdateAgentTab] = useState(false);
  const [showDepot, setShowDepot] = useState(false);
  const [showUpdateDepot, setShowUpdateDepot] = useState(false);

  // Delete modals
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordForDelete, setRecordForDelete] = useState(null);
  const [showDeleteLoader, setShowDeleteLoader] = useState(false);

  // Customer related modals
  const [deleteUserCustomerModal, setDeleteUserCustomerModal] = useState(false);
  const [userCustomerForDelete, setUserCustomerForDelete] = useState([]);
  const [showDeleteUserCustomerLoader, setShowDeleteUserCustomerLoader] =
    useState(false);
  const [defaultUserCustomerModal, setDefaultUserCustomerModal] =
    useState(false);
  const [userCustomerForDefault, setUserCustomerForDefault] = useState([]);
  const [showDefaultUserCustomerLoader, setShowDefaultUserCustomerLoader] =
    useState(false);
  const [removeDefaultUserCustomerModal, setRemoveDefaultUserCustomerModal] =
    useState(false);
  const [userCustomerForRemoveDefault, setUserCustomerForRemoveDefault] =
    useState([]);
  const [
    showRemoveDefaultUserCustomerLoader,
    setShowRemoveDefaultUserCustomerLoader,
  ] = useState(false);

  // Agent delete modal
  const [deleteUserAgentModal, setDeleteUserAgentModal] = useState(false);
  const [userAgentForDelete, setUserAgentForDelete] = useState([]);
  const [showDeleteUserAgentLoader, setShowDeleteUserAgentLoader] =
    useState(false);

  // Loaders
  const [showAddLoader, setShowAddLoader] = useState(false);
  const [showUpdateLoader, setShowUpdateLoader] = useState(false);

  // Logged in user
  const [loggedInUser, setLoggedInUser] = useState(null);
  const user_role = sessionStorage["userrole"];
  const user_id = sessionStorage["id"];

  // ---------- Add form state ----------
  const [fullName, setFullName] = useState("");
  const [userName, setUserName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [selectedRoleNames, setSelectedRoleNames] = useState([]);
  const [currentSelectedRoles, setCurrentSelectedRoles] = useState([]);
  const [selectedPorts, setSelectedPorts] = useState([]);
  const [currentSelectedPorts, setCurrentSelectedPorts] = useState([]);
  const [selectedDepot, setSelectedDepot] = useState([]);
  const [currentSelectedDepots, setCurrentSelectedDepots] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [selectedCustomerBranch, setSelectedCustomerBranch] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState([]);
  const [profilePicture, setProfilePicture] = useState(null);
  const [profile, setProfile] = useState(null);
  const [isAdmin, setIsAdmin] = useState("NO");
  const [isEmployee, setIsEmployee] = useState("NO");

  // Add validation errors
  const [showFullNameError, setShowFullNameError] = useState(false);
  const [showUsernameError, setShowUsernameError] = useState(false);
  const [showUserNameExist, setShowUserNameExist] = useState(false);
  const [showMobileError, setShowMobileError] = useState(false);
  const [showMobileExist, setShowMobileExist] = useState(false);
  const [showEmailError, setShowEmailError] = useState(false);
  const [showEmailExist, setShowEmailExist] = useState(false);

  // Add validation summary
  const [showValidationError, setShowValidationError] = useState(false);
  const [validationErrorArray, setValidationErrorArray] = useState([]);
  const [isValidationErrorVisible, setIsValidationErrorVisible] =
    useState(false);

  // ---------- Update form state ----------
  const [updateUserId, setUpdateUserId] = useState("");
  const [updateFullName, setUpdateFullName] = useState("");
  const [updateUsername, setUpdateUsername] = useState("");
  const [updateMobile, setUpdateMobile] = useState("");
  const [updateEmail, setUpdateEmail] = useState("");
  const [updateRole, setUpdateRole] = useState([]);
  const [updatePort, setUpdatePort] = useState([]);
  const [updatePortIds, setUpdatePortIds] = useState([]);
  const [updateDepot, setUpdateDepot] = useState([]);
  const [updateUserCustomer, setUpdateUserCustomer] = useState([]);
  const [updateUserCustomerIds, setUpdateUserCustomerIds] = useState([]);
  const [updateUserCustomerBranch, setUpdateUserCustomerBranch] = useState([]);
  const [updateUserAgent, setUpdateUserAgent] = useState([]);
  const [updateIsAdmin, setUpdateIsAdmin] = useState("NO");
  const [updateIsEmployee, setUpdateIsEmployee] = useState("NO");
  const [updateProfile, setUpdateProfile] = useState("");
  const [updateProfilePicture, setUpdateProfilePicture] = useState(null);

  // Update validation errors
  const [showUpdateFullNameError, setShowUpdateFullNameError] = useState(false);
  const [showUpdateMobileError, setShowUpdateMobileError] = useState(false);
  const [showUpdateEmailError, setShowUpdateEmailError] = useState(false);
  const [showUpdateUsernameError, setShowUpdateUsernameError] = useState(false);
  // Update validation summary
  const [showUpdateValidationError, setShowUpdateValidationError] =
    useState(false);
  const [updateValidationErrorArray, setUpdateValidationErrorArray] = useState(
    [],
  );
  const [isUpdateValidationErrorVisible, setIsUpdateValidationErrorVisible] =
    useState(false);

  // Password fields (disabled, not bound to state)
  const [currentPassword, setCurrentPassword] = useState(""); // only for confirm check
  const [showConfirmPasswordError, setShowConfirmPasswordError] =
    useState(false);

  // Lists for selects
  const [rolesList, setRolesList] = useState([]);
  const [portsList, setPortsList] = useState([]);
  const [depotList, setDepotList] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [customerBranchList, setCustomerBranchList] = useState([]);
  const [userAgentList, setUserAgentList] = useState([]);

  // ========== Validation Helpers ==========
  const isNumeric = (val) => /^\d+$/.test(val);

  const isValidMobile = (val) => /^\d{9,11}$/.test(val);
  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const checkIfUsernameExist = (username) =>
    data.some((user) => user.username === username);
  const checkIfMobileExist = (mobile) =>
    data.some((user) => user.mobile === mobile);
  const checkIfEmailExist = (email) =>
    data.some((user) => user.email === email);

  const hasAnyAddError = () => {
    return (
      showFullNameError ||
      showUsernameError ||
      showUserNameExist ||
      showMobileError ||
      showMobileExist ||
      showEmailError ||
      showEmailExist
    );
  };

  const buildAddErrorMessages = () => {
    const errors = [];
    if (!fullName) errors.push("Full name is required");
    if (!userName) errors.push("Username is required");
    else if (showUserNameExist) errors.push("Username already exists");
    if (!mobile) errors.push("Mobile number is required");
    else if (!isValidMobile(mobile))
      errors.push("Mobile must be a valid 9 and 11 digits ");
    else if (showMobileExist) errors.push("Mobile already registered");
    if (!email) errors.push("Email is required");
    else if (!validateEmail(email)) errors.push("Email must be valid");
    else if (showEmailExist) errors.push("Email already registered");
    return errors;
  };

  // Tooltip toggle
  const handleCheckValidationClick = () =>
    setIsValidationErrorVisible(!isValidationErrorVisible);

  // ========== Real-time error helpers for Update ==========
  const hasAnyUpdateError = () => {
    return (
      showUpdateFullNameError ||
      showUpdateUsernameError ||
      showUpdateMobileError ||
      showUpdateEmailError
    );
  };

  const buildUpdateErrorMessages = () => {
    const errors = [];
    if (!updateFullName) errors.push("Full name is required");
    if (!updateUsername) errors.push("Username is required");
    if (!updateMobile) errors.push("Mobile number is required");
    else if (!isValidMobile(updateMobile))
      errors.push("Mobile must be a valid 9 and 11 digits");
    if (!updateEmail) errors.push("Email is required");
    else if (!validateEmail(updateEmail)) errors.push("Email must be valid");
    return errors;
  };

  const handleUpdateCheckValidationClick = () =>
    setIsUpdateValidationErrorVisible(!isUpdateValidationErrorVisible);

  // ========== API calls ==========
  const getLoggedInUser = useCallback(async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/user/" + user_id,
      );
      setLoggedInUser(response.data);
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    }
  }, [user_id]);

  const getRoles = async () => {
    try {
      const roles_array = [];
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/role/",
      );
      if (response) {
        for (let i = 0; i < response.data.length; i++) {
          roles_array.push({
            value: response.data[i].id,
            label: response.data[i].role_name,
          });
        }
      }
      setRolesList(roles_array);
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    }
  };

  const getLocations = async () => {
    try {
      const locations_array = [];
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/port/",
      );
      if (response) {
        for (let i = 0; i < response.data.length; i++) {
          locations_array.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }
      }
      setPortsList(locations_array);
    } catch (err) {
      toast.error("Error in fetching port data! Try again.");
    }
  };

  const getDepot = async (port_list) => {
    try {
      const depot_array = [];
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/depot/getlocationdepot?port_list=" +
          port_list,
      );
      if (response) {
        for (let i = 0; i < response.data.length; i++) {
          depot_array.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }
      }
      setDepotList(depot_array);
    } catch (err) {
      toast.error("Error in fetching depot data! Try again.");
    }
  };

  const getCustomer = async () => {
    try {
      const customers_array = [];
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/customer/",
      );
      if (response) {
        for (let i = 0; i < response.data.length; i++) {
          customers_array.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }
      }
      setCustomerList(customers_array);
    } catch (err) {
      toast.error("Error in fetching customer data! Try again.");
    }
  };

  const getCustomerBranch = async (customer_list) => {
    if (customer_list.length === 0) {
      setCustomerBranchList([]);
      return;
    }
    try {
      const customer_branch_array = [];
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/customerbranch/getusercustomerbranch?customer_list=" +
          customer_list,
      );
      if (response) {
        for (let i = 0; i < response.data.length; i++) {
          customer_branch_array.push({
            value: response.data[i].id,
            label:
              response.data[i].port_data?.name +
              " (" +
              response.data[i].customer_data?.name +
              ")",
          });
        }
      }
      setCustomerBranchList(customer_branch_array);
    } catch (err) {
      toast.error("Error in fetching customer branch data! Try again.");
    }
  };

  const getUser = async () => {
    try {
      setDataPending(true);
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/user/",
      );
      setData(response.data);
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    } finally {
      setDataPending(false);
    }
  };

  const getAgent = async (port_list) => {
    try {
      const agent_array = [];
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/agent/getuseragent?port=" +
          port_list,
      );
      if (response) {
        if (response.data === "NO_PORT") {
          toast.warning("Select Ports to get Agents List");
          setUserAgentList([]);
        } else {
          for (let i = 0; i < response.data.length; i++) {
            agent_array.push({
              value: response.data[i].id,
              label:
                response.data[i].name +
                " (" +
                response.data[i].customer_branch_data?.port_data?.name +
                " : " +
                response.data[i].customer_branch_data?.customer_data?.name +
                ")",
            });
          }
          setUserAgentList(agent_array);
        }
      }
    } catch (err) {
      toast.error("Error in fetching agent data! Try again.");
    }
  };

  const getCurrentUserRolePermission = async (roles) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/role/getuserrolepermission?roles=" +
          roles,
      );
      const role_permissions_array = [];
      for (let i = 0; i < response.data.length; i++) {
        for (let j = 0; j < response?.data[i]?.permissions_array.length; j++) {
          if (
            !role_permissions_array.includes(
              response?.data[i]?.permissions_array?.[j],
            )
          ) {
            role_permissions_array.push(
              response?.data[i]?.permissions_array?.[j],
            );
          }
        }
      }
      setCurrentUserRolePermissionData(role_permissions_array);
    } catch (err) {
      toast.error("Error in fetching user role data! Try again.");
    }
  };

  useEffect(() => {
    getLoggedInUser();
    getUser();
    getRoles();
    getLocations();
    getCustomer();
  }, [getLoggedInUser]);

  useEffect(() => {
    getCurrentUserRolePermission(user_role);
  }, [user_role]);

  // ========== Delete handlers ==========
  const handleDeleteModalClose = () => setShowDeleteModal(false);
  const handleDeleteModalOpen = (data) => {
    setShowDeleteModal(true);
    setRecordForDelete(data);
  };

  const deleteSelectedRecord = async (id) => {
    setShowDeleteLoader(true);
    try {
      await axios.delete(
        process.env.REACT_APP_BACKEND_API_URL + "/user/user/" + id + "/",
      );
      setShowDeleteModal(false);
      getUser();
      toast.success("Record deleted successfully");
    } catch (err) {
      toast.error("Error in deleting record! Try again.");
    }
    setShowDeleteLoader(false);
  };

  // ========== Add logic ==========
  const resetAddForm = () => {
    setFullName("");
    setUserName("");
    setMobile("");
    setEmail("");
    setCurrentSelectedRoles([]);
    setSelectedRoles([]);
    setSelectedRoleNames([]);
    setCurrentSelectedPorts([]);
    setSelectedPorts([]);
    setCurrentSelectedDepots([]);
    setSelectedDepot([]);
    setSelectedCustomer([]);
    setSelectedCustomerBranch([]);
    setSelectedAgent([]);
    setProfilePicture(null);
    setProfile(null);
    setIsAdmin("NO");
    setIsEmployee("NO");
    setShowFullNameError(false);
    setShowUsernameError(false);
    setShowUserNameExist(false);
    setShowMobileError(false);
    setShowMobileExist(false);
    setShowEmailError(false);
    setShowEmailExist(false);
    setShowValidationError(false);
    setValidationErrorArray([]);
    setIsValidationErrorVisible(false);
    setShowUserDetails(true);
    setShowUserCustomerDetails(false);
    setShowUserAgentDetails(false);
    setShowCustomerTab(false);
    setShowAgentTab(false);
    setShowDepot(false);
  };

  const handleAddModalClose = () => {
    resetAddForm();
    setShowAddCanvas(false);
    setCanvasAddFullScreen(false);
  };

  const generatePassword = (length) => {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let password = "";
    for (let i = 0; i < length; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return password;
  };

  const sendConfirmationEmail = async (email, user_name, auto_password) => {
    const htmlMessage = `
    <div style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
      <h2 style="color: #12708C;">Welcome to Our Platform, ${user_name}!</h2>
      <p>Your account has been successfully created. Below are your login credentials:</p>
      <table style="border-collapse: collapse;">
        <tr><td><strong>Username:</strong></td><td>${user_name}</td></tr>
        <tr><td><strong>Password:</strong></td><td>${auto_password}</td></tr>
      </table>
      <p>You can log in at <a href="http://157.173.220.14/" style="color: #C21E22;">Inox Shipping</a>.</p>
      <p>Thank you,<br/>Inox shipping line<br/>A - 108, Hermes Atrium, Sector - 11, C.B.D Belapur, NAVI MUMBAI, MAHARASTRA 400614</p>
    </div>
    `;
    const data = {
      to: email,
      subject: "Credentials for Login",
      message: htmlMessage,
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_API_URL}/user/user/sendcredentialemail/`,
        data,
        { headers: { "Content-Type": "application/json" } },
      );
      if (response.status === 200 && response.data.status === "success") {
        toast.success("Login credentials sent via email");
      } else {
        toast.error("Email not sent. Please try again later.");
      }
    } catch (error) {
      console.error("Email send error:", error);
      toast.error("Failed to send email. Check console for details.");
    }
  };

  const addNewUser = async (e) => {
    e.preventDefault();

    setShowFullNameError(!fullName);
    setShowUsernameError(!userName);
    if (userName && checkIfUsernameExist(userName)) setShowUserNameExist(true);
    else setShowUserNameExist(false);
    setShowMobileError(!mobile || !isValidMobile(mobile));
    if (mobile && isValidMobile(mobile) && checkIfMobileExist(mobile))
      setShowMobileExist(true);
    else setShowMobileExist(false);
    setShowEmailError(!email || !validateEmail(email));
    if (email && validateEmail(email) && checkIfEmailExist(email))
      setShowEmailExist(true);
    else setShowEmailExist(false);
    setValidationErrorArray(buildAddErrorMessages());

    if (
      !fullName ||
      !userName ||
      !mobile ||
      !email ||
      !isValidMobile(mobile) ||
      !validateEmail(email) ||
      showUserNameExist ||
      showMobileExist ||
      showEmailExist
    ) {
      setShowValidationError(true);
      return;
    }

    setShowAddLoader(true);

    const auto_password = generatePassword(10);

    const formData = new FormData();
    formData.append("name", fullName);
    formData.append("username", userName);
    formData.append("mobile", mobile);
    formData.append("email", email);
    formData.append("password", auto_password);

    selectedRoles.forEach(r => formData.append("role", r));
    selectedPorts.forEach(p => formData.append("port", p));
    selectedDepot.forEach(d => formData.append("depot", d));

    formData.append("is_admin", isAdmin);
    formData.append("is_employee", isEmployee);
    if (profilePicture) formData.append("picture", profilePicture);
    formData.append("created_by", JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}));

    try {
      const response = await axios.post(
        process.env.REACT_APP_BACKEND_API_URL + "/user/user/createuser/",
        formData,
        { headers: { "content-type": "multipart/form-data" } },
      );
      if (response.status === 200) {
        toast.success("User Created Successfully");
        sendConfirmationEmail(email, userName, auto_password);
        handleAddModalClose();
        getUser();
      }
    } catch (err) {
      toast.error("Error creating user");
    } finally {
      setShowAddLoader(false);
    }
  };

  // ========== Update logic ==========
  const resetUpdateForm = () => {
    setUpdateUserId("");
    setUpdateFullName("");
    setUpdateUsername("");
    setUpdateMobile("");
    setUpdateEmail("");
    setUpdateRole([]);
    setUpdatePort([]);
    setUpdatePortIds([]);
    setUpdateDepot([]);
    setUpdateUserCustomer([]);
    setUpdateUserCustomerIds([]);
    setUpdateUserCustomerBranch([]);
    setUpdateUserAgent([]);
    setUpdateIsAdmin("NO");
    setUpdateIsEmployee("NO");
    setUpdateProfile("");
    setUpdateProfilePicture(null);
    setShowUpdateFullNameError(false);
    setShowUpdateUsernameError(false);
    setShowUpdateMobileError(false);
    setShowUpdateEmailError(false);
    setShowUpdateValidationError(false);
    setUpdateValidationErrorArray([]);
    setIsUpdateValidationErrorVisible(false);
    setShowUpdateUserDetails(true);
    setShowUpdateUserCustomerDetails(false);
    setShowUpdateUserAgentDetails(false);
    setShowUpdateCustomerTab(false);
    setShowUpdateAgentTab(false);
    setShowUpdateDepot(false);
  };

  const handleUpdateModalClose = () => {
    resetUpdateForm();
    setShowUpdateCanvas(false);
    setCanvasUpdateFullScreen(false);
  };

  const setRecordForUpdatePanel = (row) => {
    setUpdateUserId(row.id);
    setUpdateFullName(row.name);
    setUpdateUsername(row.username);
    setUpdateMobile(row.mobile);
    setUpdateEmail(row.email);
    setUpdateIsAdmin(row.is_admin ? "YES" : "NO");
    setUpdateIsEmployee(row.is_employee ? "YES" : "NO");
    setUpdateProfile(row.picture);
    setCustomerBranchData(
      row.additional_information?.[0]?.["customer_branch"] || [],
    );
    setUserAgentData(row.agent_data || []);

    // Roles
    const roles_array = row.role_data.map((r) => ({
      value: r.id,
      label: r.role_name,
    }));
    setUpdateRole(roles_array);
    const role_names = row.role_data.map((r) => r.role_name);

    setShowUpdateDepot(role_names.includes("Depot User"));
    setShowUpdateCustomerTab(role_names.includes("Customer"));
    setShowUpdateAgentTab(role_names.includes("Agent"));

    // Ports
    const ports_array = row.port_data.map((p) => ({
      value: p.id,
      label: p.name,
    }));
    setUpdatePort(ports_array);
    setUpdatePortIds(row.port_data.map((p) => p.id));

    // Depots
    const depots_array = row.depot_data.map((d) => ({
      value: d.id,
      label: d.name,
    }));
    setUpdateDepot(depots_array);

    // Customers
    const customers_array = row.customer_data.map((c) => ({
      value: c.id,
      label: c.name,
    }));
    setUpdateUserCustomer(customers_array);
    setUpdateUserCustomerIds(row.customer_data.map((c) => c.id));

    // Customer Branches
    const branches_array = row.customer_branch_data.map((b) => ({
      value: b.id,
      label: b.port_data?.name,
    }));
    setUpdateUserCustomerBranch(branches_array);

    // Agents
    const agents_array = row.agent_data.map((a) => ({
      value: a.id,
      label:
        a.name +
        " (" +
        a.customer_branch_data?.port_data?.name +
        " : " +
        a.customer_branch_data?.customer_data?.name +
        ")",
    }));
    setUpdateUserAgent(agents_array);

    // Fetch dependent data
    if (row.port_data.length > 0) {
      getDepot(row.port_data.map((p) => p.id));
      getAgent(row.port_data.map((p) => p.id));
    }
    if (row.customer_data.length > 0) {
      getCustomerBranch(row.customer_data.map((c) => c.id));
    }

    setShowUpdateUserDetails(true);
    setShowUpdateUserCustomerDetails(false);
    setShowUpdateUserAgentDetails(false);
  };

  const updateUser = async (e) => {
    e.preventDefault();

    // Simple validation for required fields
    setShowUpdateFullNameError(!updateFullName);
    setShowUpdateMobileError(!updateMobile || !isValidMobile(updateMobile));
    setShowUpdateEmailError(!updateEmail || !validateEmail(updateEmail));
    setUpdateValidationErrorArray(buildUpdateErrorMessages());

    if (
      !updateFullName ||
      !updateMobile ||
      !updateEmail ||
      !isValidMobile(updateMobile) ||
      !validateEmail(updateEmail)
    ) {
      setShowUpdateValidationError(true);
      return;
    }

    setShowUpdateLoader(true);

    const formData = new FormData();
    formData.append("user_id", updateUserId);
    formData.append("name", updateFullName);
    formData.append("username", updateUsername);
    formData.append("mobile", updateMobile);
    formData.append("email", updateEmail);

    updateRole.forEach(r => formData.append("role", r.value));
    updatePort.forEach(p => formData.append("port", p.value));
    updateDepot.forEach(d => formData.append("depot", d.value));
  
    // formData.append("customer", JSON.stringify(updateUserCustomer.map((c) => c.value)),);
    // formData.append("customer_branch", JSON.stringify(updateUserCustomerBranch.map((b) => b.value)),);
    // formData.append("agent", JSON.stringify(updateUserAgent.map((a) => a.value)),);

    updateUserCustomer.forEach(c => formData.append("customer", c.value));
    updateUserCustomerBranch.forEach(cb => formData.append("customer_branch", cb.value));
    updateUserAgent.forEach(ua => formData.append("agent", ua.value));

    formData.append("is_admin", updateIsAdmin);
    formData.append("is_employee", updateIsEmployee);
    if (updateProfilePicture) formData.append("picture", updateProfilePicture);
    formData.append("modified_by", JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}));

    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL + "/user/user/updateuser/",
        formData,
        { headers: { "content-type": "multipart/form-data" } },
      );
      if (response.status === 201) {
        toast.success("User updated Successfully");
        handleUpdateModalClose();
        getUser();
      }
    } catch (err) {
      toast.error("Error updating user");
    } finally {
      setShowUpdateLoader(false);
    }
  };

  // ========== Select handlers for add ==========
  const selectedUserRoles = (roledata) => {
    setCurrentSelectedRoles(roledata);
    if (roledata.length > 0) {
      const rolearray = roledata.map((r) => r.value);
      const rolenamearray = roledata.map((r) => r.label);
      setSelectedRoles(rolearray);
      setSelectedRoleNames(rolenamearray);
      setShowDepot(rolenamearray.includes("Depot User"));
      setShowCustomerTab(rolenamearray.includes("Customer"));
      setShowAgentTab(rolenamearray.includes("Agent"));
    } else {
      setSelectedRoles([]);
      setSelectedRoleNames([]);
      setShowDepot(false);
      setShowCustomerTab(false);
      setShowAgentTab(false);
    }
  };

  const selectedUserLocations = (locationdata) => {
    setCurrentSelectedPorts(locationdata);
    if (locationdata.length > 0) {
      const portarray = locationdata.map((l) => l.value);
      setSelectedPorts(portarray);
      if (showDepot) getDepot(portarray);
    } else {
      setSelectedPorts([]);
      setSelectedDepot([]);
      setDepotList([]);
    }
  };

  const selectedUserDepot = (depotdata) => {
    setCurrentSelectedDepots(depotdata);
    if (depotdata.length > 0) {
      setSelectedDepot(depotdata.map((d) => d.value));
    } else {
      setSelectedDepot([]);
    }
  };

  const selectedUserCustomer = (customerdata) => {
    if (customerdata.length > 0) {
      const customerarray = customerdata.map((c) => c.value);
      setSelectedCustomer(customerarray);
      getCustomerBranch(customerarray);
    } else {
      setSelectedCustomer([]);
      setSelectedCustomerBranch([]);
      setCustomerBranchList([]);
    }
  };

  const selectedUserCustomerBranch = (branchdata) => {
    if (branchdata.length > 0) {
      setSelectedCustomerBranch(branchdata.map((b) => b.value));
    } else {
      setSelectedCustomerBranch([]);
    }
  };

  const selectedUserAgent = (agentdata) => {
    if (agentdata.length > 0) {
      setSelectedAgent(agentdata.map((a) => a.value));
    } else {
      setSelectedAgent([]);
    }
  };

  // ========== Select handlers for update ==========
  const selectedUserRolesForUpdate = (roledata) => {
    setUpdateRole(roledata);
    const rolenames = roledata.map((r) => r.label);
    setShowUpdateDepot(rolenames.includes("Depot User"));
    setShowUpdateCustomerTab(rolenames.includes("Customer"));
    setShowUpdateAgentTab(rolenames.includes("Agent"));
    if (!rolenames.includes("Depot User")) setUpdateDepot([]);
  };

  const selectedUserPortsForUpdate = (portdata) => {
    setUpdatePort(portdata);
    const portarray = portdata.map((p) => p.value);
    if (showUpdateDepot) {
      if (portarray.length > 0) getDepot(portarray);
      else {
        setUpdateDepot([]);
        setDepotList([]);
      }
    }
  };

  const selectedUserDepotForUpdate = (depotdata) => {
    setUpdateDepot(depotdata);
  };

  const selectedUserCustomerForUpdate = (customerdata) => {
    setUpdateUserCustomer(customerdata);
    const customerarray = customerdata.map((c) => c.value);
    if (customerarray.length > 0) {
      getCustomerBranch(customerarray);
    } else {
      setUpdateUserCustomerBranch([]);
      setCustomerBranchList([]);
    }
  };

  const selectedUserCustomerBranchForUpdate = (branchdata) => {
    setUpdateUserCustomerBranch(branchdata);
  };

  const selectedUserAgentForUpdate = (agentdata) => {
    setUpdateUserAgent(agentdata);
  };

  // ========== Customer and Agent delete handlers ==========
  const handleDeleteUserCustomerModalOpen = (data) => {
    setDeleteUserCustomerModal(true);
    setUserCustomerForDelete([updateUserId, data.customer, data.branch_port]);
  };

  const deleteUserCustomerRecord = async (customerrecord) => {
    setShowDeleteUserCustomerLoader(true);
    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/user/deletecustomeruser/",
        {
          user_id: customerrecord[0],
          customer: customerrecord[1],
          port: customerrecord[2],
          modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
        },
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 201) {
        toast.success("User Removed from customer Successfully");
        setCustomerBranchData(
          response.data?.additional_information?.[0]?.["customer_branch"] || [],
        );
        getUser();
      }
    } catch (err) {
      toast.error("Error removing customer");
    } finally {
      setShowDeleteUserCustomerLoader(false);
      setDeleteUserCustomerModal(false);
    }
  };

  const handleDefaultUserCustomerModalOpen = (data) => {
    setDefaultUserCustomerModal(true);
    setUserCustomerForDefault([updateUserId, data.customer, data.branch_port]);
  };

  const defaultUserCustomerRecord = async (customerrecord) => {
    setShowDefaultUserCustomerLoader(true);
    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL + "/user/user/updatedefaultuser/",
        {
          user_id: customerrecord[0],
          customer: customerrecord[1],
          port: customerrecord[2],
          modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
        },
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 201) {
        toast.success("Defaults updated Successfully");
        setCustomerBranchData(
          response.data?.additional_information?.[0]?.["customer_branch"] || [],
        );
        getUser();
      }
    } catch (err) {
      toast.error("Error setting default");
    } finally {
      setShowDefaultUserCustomerLoader(false);
      setDefaultUserCustomerModal(false);
    }
  };

  const handleRemoveDefaultUserCustomerModalOpen = (data) => {
    setRemoveDefaultUserCustomerModal(true);
    setUserCustomerForRemoveDefault([
      updateUserId,
      data.customer,
      data.branch_port,
    ]);
  };

  const removeDefaultUserCustomerRecord = async (customerrecord) => {
    setShowRemoveDefaultUserCustomerLoader(true);
    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL + "/user/user/removedefaultuser/",
        {
          user_id: customerrecord[0],
          customer: customerrecord[1],
          port: customerrecord[2],
          modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
        },
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 201) {
        toast.success("Defaults updated Successfully");
        setCustomerBranchData(
          response.data?.additional_information?.[0]?.["customer_branch"] || [],
        );
        getUser();
      }
    } catch (err) {
      toast.error("Error removing default");
    } finally {
      setShowRemoveDefaultUserCustomerLoader(false);
      setRemoveDefaultUserCustomerModal(false);
    }
  };

  const handleDeleteUserAgentOpen = (row) => {
    setDeleteUserAgentModal(true);
    setUserAgentForDelete(row);
  };

  const deleteUserAgentRecord = async (agent) => {
    setShowDeleteUserAgentLoader(true);
    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL + "/user/user/deleteuseragent/",
        {
          id: updateUserId,
          agent: agent.id,
          modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
        },
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 201) {
        toast.success("User Removed from agent Successfully");
        setUserAgentData(response.data.agent_data || []);
        setCustomerBranchData(
          response.data?.additional_information?.[0]?.["customer_branch"] || [],
        );
        getUser();
      }
    } catch (err) {
      toast.error("Error removing agent");
    } finally {
      setShowDeleteUserAgentLoader(false);
      setDeleteUserAgentModal(false);
    }
  };

  // ========== Table columns ==========
  const columns = [
    {
      name: "Profile",
      width: "100px",
      selector: (row) => (
        <img
          src={row.picture || PlaceholderPicture}
          className="img img-thumbnail"
          style={{ height: 50, width: 50 }}
          alt="profile"
        />
      ),
    },
    { name: "Name", selector: (row) => row.name, sortable: true },
    { name: "Username", selector: (row) => row.username, sortable: true },
    { name: "Mobile", selector: (row) => row.mobile, sortable: true },
    {
      name: "Email",
      width: "300px",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Is Admin",
      width: "110px",
      selector: (row) => (row.is_admin ? "Yes" : "No"),
      sortable: true,
    },
    {
      name: "Details",
      width: "500px",
      selector: (row) => (
        <>
          {row.role_data.length > 0 && (
            <>
              <span className="fw-bold">Roles: </span>
              {row.role_data.map((role, index) => (
                <span key={index}>
                  {index !== 0 ? ", " : ""}
                  {role.role_name}
                </span>
              ))}
            </>
          )}
          {row.port_data.length > 0 && (
            <>
              <br />
              <span className="fw-bold">Locations: </span>
              {row.port_data.map((port, index) => (
                <span key={index}>
                  {index !== 0 ? ", " : ""}
                  {port.name}
                </span>
              ))}
            </>
          )}
          {row.depot_data.length > 0 && (
            <>
              <br />
              <span className="fw-bold">Depots: </span>
              {row.depot_data.map((depot, index) => (
                <span key={index}>
                  {index !== 0 ? ", " : ""}
                  {depot.name}
                </span>
              ))}
            </>
          )}
        </>
      ),
    },
    {
      name: "Action",
      center: true,
      width: "110px",
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes("master:user:update") && (
            <Button
              className="btn btn-sm btn-inox-green border-0"
              title="Update"
              onClick={() => {
                setRecordForUpdatePanel(row);
                setShowUpdateCanvas(true);
              }}
            >
              <i className="fa fa-edit"></i>
            </Button>
          )}
          {currentUserRolePermissionData?.includes("master:user:delete") && (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => handleDeleteModalOpen(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          )}
        </div>
      ),
    },
  ];

  const customerbranchcolumns = [
    { name: "Customer", selector: (row) => row.customer, sortable: true },
    { name: "Branch", selector: (row) => row.branch_port, sortable: true },
    {
      name: "Address",
      width: "500px",
      selector: (row) => row.address,
      sortable: true,
    },
    { name: "Is Default", selector: (row) => row.is_default, sortable: true },
    {
      name: "Action",
      center: true,
      width: "130px",
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes("master:user:delete") &&
            (row.is_default === "NO" ? (
              <Button
                className="btn btn-sm btn-inox-green border-0 mx-2"
                title="Make Default"
                onClick={() => handleDefaultUserCustomerModalOpen(row)}
              >
                <i className="fa fa-check"></i>
              </Button>
            ) : (
              <Button
                className="btn btn-sm btn-secondary border-0 mx-2"
                title="Remove Default"
                onClick={() => handleRemoveDefaultUserCustomerModalOpen(row)}
              >
                <i className="fa fa-times"></i>
              </Button>
            ))}
          {currentUserRolePermissionData?.includes("master:user:delete") && (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => handleDeleteUserCustomerModalOpen(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          )}
        </div>
      ),
    },
  ];

  const useragentcolumns = [
    { name: "Name", selector: (row) => row.name, sortable: true },
    {
      name: "Location",
      width: "300px",
      selector: (row) =>
        row.customer_branch_data?.port_data?.name +
        " (" +
        row.customer_branch_data?.customer_data?.name +
        ")",
    },
    {
      name: "Address",
      width: "600px",
      selector: (row) =>
        row.address_line_1 +
        ", " +
        row.address_line_2 +
        ", " +
        row.city +
        ", " +
        row.state +
        ", " +
        row.pincode,
    },
    {
      name: "Country",
      center: true,
      selector: (row) => (
        <div className="text-center">
          <img
            src={row.country_data?.image_url}
            height={20}
            width={35}
            style={{ marginBottom: 5 }}
            alt="flag"
          />
          <br />
          <span>{row.country_data?.long_name}</span>
        </div>
      ),
    },
    { name: "Own Office", selector: (row) => row.own_office },
    {
      name: "Action",
      center: true,
      width: "130px",
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes("master:user:delete") && (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => handleDeleteUserAgentOpen(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          )}
        </div>
      ),
    },
  ];

  const handleDataFromTopNavBar = (permissiondata) =>
    setDataFromTopNavBar(permissiondata);

  return (
    <div className="page-content-bg">
      <ToastContainer />
      <TopNavbar
        sidebarCollapsed={menuDrawerShow}
        topNavbarStatic={true}
        sendDataToParent={handleDataFromTopNavBar}
      />
      <SideNavbar
        sidebarCollapsed={menuDrawerShow}
        activeMenu="Master"
        activeSubMenu="AdminMaster"
        activeSubMenuLevel1="UserMaster"
        permissionFromTopNavbar={dataFromTopNavBar}
      />

      <div
        className={
          menuDrawerShow
            ? "row main-content-collapsed text-left py-0"
            : "row main-content text-left py-0"
        }
      >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-6 py-1">
              <Button
                className="btn btn-sm btn-inox-green border-0 mx-2"
                onClick={() => setMenuDrawerShow(!menuDrawerShow)}
              >
                {menuDrawerShow ? (
                  <span>
                    <i className="fa fa-chevron-left mx-1"></i>
                  </span>
                ) : (
                  <span>
                    <i className="fa fa-chevron-right mx-1"></i>
                  </span>
                )}
              </Button>
              <span className="page-header-text">User Master</span>
            </div>
            <div className="col-6 py-1" style={{ paddingRight: 30 }}>
              {currentUserRolePermissionData?.includes("master:user:add") && (
                <Button
                  className="btn btn-sm btn-inox-green border-0 px-3 float-right"
                  onClick={() => {
                    resetAddForm();
                    setShowAddCanvas(true);
                  }}
                >
                  <i
                    className="fa fa-plus fa-lg text-right"
                    style={{ paddingRight: 10 }}
                  ></i>
                  <span className="fw-bold">Add User</span>
                </Button>
              )}
            </div>
          </div>
        </div>

        <div
          className="col-12 text-left"
          style={{
            marginTop: -5,
            paddingLeft: 20,
            paddingRight: 30,
            zIndex: 100,
          }}
        >
          <DataTable
            columns={columns}
            data={data}
            progressPending={dataPending}
            progressComponent={
              <Spinner
                className="mx-5 text-inox-green table-spinner"
                as="span"
                animation="border"
                size="lg"
                role="status"
                aria-hidden="true"
              />
            }
            noDataComponent={
              <p className="text-center table-no-data">No Data Found</p>
            }
            pagination
            highlightOnHover
            fixedHeader
            customStyles={userTableCustomStyles}
            onRowClicked={(row) => {
                setRecordForUpdatePanel(row);
                setShowUpdateCanvas(true);
              }}
            pointerOnHover
            dense
          />
        </div>
      </div>

      {/* Delete Modals */}
      <Modal
        size="sm"
        show={showDeleteModal}
        onHide={handleDeleteModalClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Delete{" "}
            <span className="font-12px">( {recordForDelete?.name} )</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModalClose}>
            Close
          </Button>
          <Button
            variant="danger"
            onClick={() => deleteSelectedRecord(recordForDelete?.id)}
          >
            {showDeleteLoader ? (
              <Spinner
                className="mx-3 text-white"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        size="sm"
        show={deleteUserCustomerModal}
        onHide={() => setDeleteUserCustomerModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Delete{" "}
            <span className="font-12px">( {userCustomerForDelete[1]} )</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Do you want to remove association from this customer?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setDeleteUserCustomerModal(false)}
          >
            Close
          </Button>
          <Button
            variant="danger"
            onClick={() => deleteUserCustomerRecord(userCustomerForDelete)}
          >
            {showDeleteUserCustomerLoader ? (
              <Spinner
                className="mx-3 text-white"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        size="sm"
        show={defaultUserCustomerModal}
        onHide={() => setDefaultUserCustomerModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Set Default{" "}
            <span className="font-12px">( {userCustomerForDefault[1]} )</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to set this as default?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setDefaultUserCustomerModal(false)}
          >
            Close
          </Button>
          <Button
            className="btn btn-inox-green text-white"
            onClick={() => defaultUserCustomerRecord(userCustomerForDefault)}
          >
            {showDefaultUserCustomerLoader ? (
              <Spinner
                className="mx-3 text-white"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Make Default"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        size="sm"
        show={removeDefaultUserCustomerModal}
        onHide={() => setRemoveDefaultUserCustomerModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Remove Default{" "}
            <span className="font-12px">
              ( {userCustomerForRemoveDefault[1]} )
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to remove this user from default?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setRemoveDefaultUserCustomerModal(false)}
          >
            Close
          </Button>
          <Button
            className="btn btn-inox-green text-white"
            onClick={() =>
              removeDefaultUserCustomerRecord(userCustomerForRemoveDefault)
            }
          >
            {showRemoveDefaultUserCustomerLoader ? (
              <Spinner
                className="mx-3 text-white"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Remove Default"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        size="sm"
        show={deleteUserAgentModal}
        onHide={() => setDeleteUserAgentModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Agent Association</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Do you want to remove association from this agent?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setDeleteUserAgentModal(false)}
          >
            Close
          </Button>
          <Button
            variant="danger"
            onClick={() => deleteUserAgentRecord(userAgentForDelete)}
          >
            {showDeleteUserAgentLoader ? (
              <Spinner
                className="mx-3 text-white"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ------------------------ Update Canvas ------------------- */}
      <div
        className={
          canvasUpdateFullScreen && showUpdateCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasUpdateFullScreen && showUpdateCanvas
              ? "offcanvas offcanvas-bottom h-50 show"
              : "offcanvas offcanvas-bottom h-50"
        }
        tabIndex="-1"
        aria-labelledby="updateCanvasLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-5">
              <h4 id="updateCanvasLabel" className="float-left px-3">
                Update Record{" "}
                <span className="font-14px">( {updateFullName} )</span>
              </h4>
              <Button
                className={`${showUpdateUserDetails ? "btn-inox-red" : "btn-inox-green"} border-0 btn-sm`}
                style={{ marginRight: 10, width: 120 }}
                onClick={() => {
                  setShowUpdateUserDetails(true);
                  setShowUpdateUserCustomerDetails(false);
                  setShowUpdateUserAgentDetails(false);
                }}
              >
                Details
              </Button>
              {showUpdateCustomerTab && (
                <Button
                  className={`${showUpdateUserCustomerDetails ? "btn-inox-red" : "btn-inox-green"} border-0 btn-sm`}
                  style={{ marginRight: 10, width: 120 }}
                  onClick={() => {
                    setShowUpdateUserDetails(false);
                    setShowUpdateUserCustomerDetails(true);
                    setShowUpdateUserAgentDetails(false);
                  }}
                >
                  Customer
                </Button>
              )}
              {showUpdateAgentTab && (
                <Button
                  className={`${showUpdateUserAgentDetails ? "btn-inox-red" : "btn-inox-green"} border-0 btn-sm`}
                  style={{ marginRight: 10, width: 120 }}
                  onClick={() => {
                    setShowUpdateUserDetails(false);
                    setShowUpdateUserCustomerDetails(false);
                    setShowUpdateUserAgentDetails(true);
                  }}
                >
                  Agent
                </Button>
              )}
            </div>
            <div className="col-7">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                aria-label="Close"
                title="Close"
                onClick={handleUpdateModalClose}
              >
                <i className="fa fa-times text-white"></i>
              </button>
              {canvasUpdateFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => setCanvasUpdateFullScreen(false)}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => setCanvasUpdateFullScreen(true)}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>
        <div
          className="offcanvas-body"
          style={{ paddingLeft: 200, paddingRight: 200 }}
        >
          {/* Details Tab */}
          <form
                id="update-user-form"
                onSubmit={updateUser}
                encType="multipart/form-data"
              >
          {showUpdateUserDetails && (
            <div style={{ fontSize: 13 }}>
              
                <div className="row">
                  <div className="col-md-2">
                    <div>
                      <img
                        src={updateProfile || PlaceholderPicture}
                        className="img img-thumbnail mb-2 w-100"
                        style={{ height: 175 }}
                        alt="profile"
                      />
                      <input
                        type="file"
                        accept="image/jpeg,image/jpg,image/png,image/gif"
                        className="form-control"
                        name="profile_img"
                        onChange={(e) => {
                          setUpdateProfilePicture(e.target.files[0]);
                          setUpdateProfile(
                            URL.createObjectURL(e.target.files[0]),
                          );
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-10">
                    <div className="row">
                      <div
                        className={`form-group ${canvasUpdateFullScreen ? "col-md-6" : "col-md-4"} text-left mb-4`}
                      >
                        <label htmlFor="update_full_name">
                          Full Name:{" "}
                          <span className="text-danger">
                            {showUpdateFullNameError ? "Name is required" : ""}
                          </span>
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          id="update_full_name"
                          placeholder="Enter Full Name"
                          value={updateFullName}
                          onChange={(e) => {
                            setUpdateFullName(e.target.value);
                            setShowUpdateFullNameError(false);
                            setShowUpdateValidationError(false);
                          }}
                          onBlur={(e) =>
                            setShowUpdateFullNameError(e.target.value === "")
                          }
                        />
                      </div>
                      <div
                        className={`form-group ${canvasUpdateFullScreen ? "col-md-6" : "col-md-4"} text-left mb-4`}
                      >
                        <label htmlFor="update_username">
                          Username:
                          <span className="text-danger">
                            {showUpdateUsernameError
                              ? "Username is required"
                              : ""}
                          </span>
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          id="update_username"
                          value={updateUsername}
                          onChange={(e) => {
                            setUpdateUsername(e.target.value);
                            setShowUpdateUsernameError(e.target.value === "");
                          }}
                          onBlur={(e) =>
                            setShowUpdateUsernameError(e.target.value === "")
                          }
                          placeholder="Enter Username"
                        />
                      </div>
                      <div
                        className={`form-group ${canvasUpdateFullScreen ? "col-md-6" : "col-md-4"} text-left mb-4`}
                      >
                        <label htmlFor="update_mobile">
                          Mobile:{" "}
                          <span className="text-danger">
                            {showUpdateMobileError
                              ? "Valid number required"
                              : ""}
                          </span>
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          id="update_mobile"
                          placeholder="Enter Mobile"
                          value={updateMobile}
                          onChange={(e) => {
                            setUpdateMobile(e.target.value);
                            setShowUpdateMobileError(false);
                            setShowUpdateValidationError(false);
                          }}
                          onBlur={(e) =>
                            setShowUpdateMobileError(
                              !e.target.value || !isValidMobile(e.target.value),
                            )
                          }
                        />
                      </div>
                      <div
                        className={`form-group ${canvasUpdateFullScreen ? "col-md-6" : "col-md-4"} text-left mb-4`}
                      >
                        <label htmlFor="update_email">
                          Email:{" "}
                          <span className="text-danger">
                            {showUpdateEmailError ? "Valid email required" : ""}
                          </span>
                        </label>
                        <input
                          type="email"
                          className="form-control form-control-sm"
                          id="update_email"
                          placeholder="Enter Email Address"
                          value={updateEmail}
                          onChange={(e) => {
                            setUpdateEmail(e.target.value);
                            setShowUpdateEmailError(false);
                            setShowUpdateValidationError(false);
                          }}
                          onBlur={(e) =>
                            setShowUpdateEmailError(
                              !e.target.value || !validateEmail(e.target.value),
                            )
                          }
                        />
                      </div>
                      <div
                        className={`form-group ${canvasUpdateFullScreen ? "col-md-6" : "col-md-4"} text-left mb-4`}
                      >
                        <label htmlFor="update_password">Password:</label>
                        <input
                          type="password"
                          className="form-control form-control-sm"
                          id="update_password"
                          placeholder="Enter Password"
                          disabled
                        />
                      </div>
                      <div
                        className={`form-group ${canvasUpdateFullScreen ? "col-md-6" : "col-md-4"} text-left mb-4`}
                      >
                        <label htmlFor="update_confirm_password">
                          Confirm Password:{" "}
                          <span className="text-danger">
                            {showConfirmPasswordError
                              ? "Password not matching"
                              : ""}
                          </span>
                        </label>
                        <input
                          type="password"
                          className="form-control form-control-sm"
                          id="update_confirm_password"
                          placeholder="Enter Similar Password"
                          disabled
                        />
                      </div>
                      <div
                        className={`form-group ${canvasUpdateFullScreen ? "col-md-6" : "col-md-4"} text-left mb-4`}
                      >
                        <label htmlFor="update_user_role">Role:</label>
                        <Select
                          options={rolesList}
                          id="update_user_role"
                          onChange={selectedUserRolesForUpdate}
                          maxMenuHeight={canvasUpdateFullScreen ? 1000 : 200}
                          value={updateRole}
                          styles={smallFormSelectCustomStyles}
                          isMulti
                          isClearable
                        />
                      </div>
                      <div
                        className={`form-group ${canvasUpdateFullScreen ? "col-md-6" : "col-md-4"} text-left mb-4`}
                      >
                        <label htmlFor="update_user_port">Port:</label>
                        <Select
                          options={portsList}
                          id="update_user_port"
                          onChange={selectedUserPortsForUpdate}
                          maxMenuHeight={canvasUpdateFullScreen ? 1000 : 200}
                          value={updatePort}
                          styles={smallFormSelectCustomStyles}
                          isMulti
                          isClearable
                        />
                        {showUpdateDepot && (
                          <>
                            <label htmlFor="update_user_depot" className="mt-4">
                              Depot:
                            </label>
                            <Select
                              options={depotList}
                              id="update_user_depot"
                              onChange={selectedUserDepotForUpdate}
                              maxMenuHeight={
                                canvasUpdateFullScreen ? 1000 : 200
                              }
                              value={updateDepot}
                              styles={smallFormSelectCustomStyles}
                              isMulti
                              isClearable
                            />
                          </>
                        )}
                      </div>
                      <div
                        className={`form-group ${canvasUpdateFullScreen ? "col-md-6" : "col-md-4"} text-left mb-4`}
                      >
                        <label htmlFor="update_is_admin">Is Admin:</label>
                        <select
                          className="form-select form-select-sm"
                          id="update_is_admin"
                          value={updateIsAdmin}
                          onChange={(e) => setUpdateIsAdmin(e.target.value)}
                        >
                          <option value="YES">YES</option>
                          <option value="NO">NO</option>
                        </select>
                        <label htmlFor="update_is_employee" className="mt-4">
                          Is Employee:
                        </label>
                        <select
                          className="form-select form-select-sm"
                          id="update_is_employee"
                          value={updateIsEmployee}
                          onChange={(e) => setUpdateIsEmployee(e.target.value)}
                        >
                          <option value="YES">YES</option>
                          <option value="NO">NO</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          )}

          {/* Customer Tab */}
          {showUpdateUserCustomerDetails && (
            <div style={{ fontSize: 13 }}>
              <div className="row">
                <div
                  className={`form-group ${canvasUpdateFullScreen ? "col-md-6" : "col-md-6"} text-left mb-4`}
                >
                  <label htmlFor="update_user_customer">Customer:</label>
                  <Select
                    options={customerList}
                    id="update_user_customer"
                    onChange={selectedUserCustomerForUpdate}
                    maxMenuHeight={canvasUpdateFullScreen ? 1000 : 200}
                    value={updateUserCustomer}
                    isMulti
                    isClearable
                  />
                </div>
                <div
                  className={`form-group ${canvasUpdateFullScreen ? "col-md-6" : "col-md-6"} text-left mb-4`}
                >
                  <label htmlFor="update_user_customer_branch">Branch:</label>
                  <Select
                    options={customerBranchList}
                    id="update_user_customer_branch"
                    onChange={selectedUserCustomerBranchForUpdate}
                    maxMenuHeight={canvasUpdateFullScreen ? 1000 : 200}
                    value={updateUserCustomerBranch}
                    isMulti
                    isClearable
                  />
                </div>
              </div>
              <DataTable
                columns={customerbranchcolumns}
                data={customerBranchData}
                progressPending={branchDataPending}
                progressComponent={
                  <Spinner
                    className="mx-5 text-inox-green table-spinner"
                    as="span"
                    animation="border"
                    size="lg"
                    role="status"
                    aria-hidden="true"
                  />
                }
                noDataComponent={
                  <p className="text-center my-5 py-5">
                    User not associated with any customer
                  </p>
                }
                pagination
                highlightOnHover
                fixedHeader
                customStyles={userTableCustomStyles}
                dense
              />
            </div>
          )}

          {/* Agent Tab */}
          {showUpdateUserAgentDetails && (
            <div style={{ fontSize: 13 }}>
              <div className="row">
                <div
                  className={`form-group ${canvasUpdateFullScreen ? "col-md-12" : "col-md-12"} text-left mb-4`}
                >
                  <label htmlFor="update_user_agent">Agent:</label>
                  <Select
                    options={userAgentList}
                    id="update_user_agent"
                    onChange={selectedUserAgentForUpdate}
                    maxMenuHeight={canvasUpdateFullScreen ? 1000 : 200}
                    value={updateUserAgent}
                    isMulti
                    isClearable
                  />
                </div>
              </div>
              <DataTable
                columns={useragentcolumns}
                data={userAgentData}
                progressPending={branchDataPending}
                progressComponent={
                  <Spinner
                    className="mx-5 text-inox-green table-spinner"
                    as="span"
                    animation="border"
                    size="lg"
                    role="status"
                    aria-hidden="true"
                  />
                }
                noDataComponent={
                  <p className="text-center my-5 py-5">
                    User not associated with any agent
                  </p>
                }
                pagination
                highlightOnHover
                fixedHeader
                customStyles={userTableCustomStyles}
                dense
              />
            </div>
          )}

          <div className="canvas-btn-row mt-4">
            <Button
              type="submit"
              form="update-user-form"
              className="btn btn-inox-green border-0 canvas-button"
              disabled={hasAnyUpdateError() || showUpdateLoader}
            >
              {showUpdateLoader ? (
                <Spinner
                  className="mx-5 text-white"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                <>
                  <i className="fa fa-edit"></i>{" "}
                  <span className="mx-2">Update</span>
                </>
              )}
            </Button>

            {(hasAnyUpdateError() || showUpdateValidationError) && (
              <div className="error-tooltip-wrapper">
                <Button
                  style={{
                    backgroundColor: "#C21E22",
                    border: "#f82e2e",
                  }}
                  title="Show Errors"
                  className="mx-2"
                  onClick={handleUpdateCheckValidationClick}
                  onMouseLeave={() => setIsUpdateValidationErrorVisible(false)}
                >
                  <i className="fa fa-exclamation"></i>
                </Button>
                {isUpdateValidationErrorVisible && (
                  <div className="validation-error-tooltip">
                    <ul className="mb-0 px-4">
                      {buildUpdateErrorMessages().map((error, index) => (
                        <li key={index} className="text-left small pb-0">
                          {error}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            )}
          </div>
          </form>
        </div>
      </div>

      {/* ------------------------ Add Canvas ------------------- */}
      <div
        className={
          canvasAddFullScreen && showAddCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasAddFullScreen && showAddCanvas
              ? "offcanvas offcanvas-bottom h-50 show"
              : "offcanvas offcanvas-bottom h-50"
        }
        tabIndex="-1"
        aria-labelledby="addCanvasLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="addCanvasLabel" className="float-left">
                Add New User
              </h4>
              <Button
                className={`${showUserDetails ? "btn-inox-red" : "btn-inox-green"} border-0 btn-sm`}
                style={{ marginRight: 10, width: 120 }}
                onClick={() => {
                  setShowUserDetails(true);
                  setShowUserCustomerDetails(false);
                  setShowUserAgentDetails(false);
                }}
              >
                Details
              </Button>
              {showCustomerTab && (
                <Button
                  className={`${showUserCustomerDetails ? "btn-inox-red" : "btn-inox-green"} border-0 btn-sm`}
                  style={{ marginRight: 10, width: 120 }}
                  onClick={() => {
                    setShowUserDetails(false);
                    setShowUserCustomerDetails(true);
                    setShowUserAgentDetails(false);
                  }}
                >
                  Customer
                </Button>
              )}
              {showAgentTab && (
                <Button
                  className={`${showUserAgentDetails ? "btn-inox-red" : "btn-inox-green"} border-0 btn-sm`}
                  style={{ marginRight: 10, width: 120 }}
                  onClick={() => {
                    setShowUserDetails(false);
                    setShowUserCustomerDetails(false);
                    setShowUserAgentDetails(true);
                    if (selectedPorts.length > 0) getAgent(selectedPorts);
                  }}
                >
                  Agent
                </Button>
              )}
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                aria-label="Close"
                title="Close"
                onClick={handleAddModalClose}
              >
                <i className="fa fa-times text-white"></i>
              </button>
              {canvasAddFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => setCanvasAddFullScreen(false)}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => setCanvasAddFullScreen(true)}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div
          className="offcanvas-body"
          style={{ paddingLeft: 200, paddingRight: 200 }}
        >
          {/* Details Tab */}
          {showUserDetails && (
            <div style={{ fontSize: 13 }}>
              <form
                id="add-user-form"
                onSubmit={addNewUser}
                encType="multipart/form-data"
              >
                <div className="row">
                  <div className="col-md-2">
                    <div>
                      <img
                        src={profile || PlaceholderPicture}
                        className="img img-thumbnail mb-2 w-100"
                        style={{ height: 175 }}
                        alt="profile"
                      />
                      <input
                        type="file"
                        accept="image/jpeg,image/jpg,image/png,image/gif"
                        className="form-control"
                        name="profile_img"
                        onChange={(e) => {
                          setProfilePicture(e.target.files[0]);
                          setProfile(URL.createObjectURL(e.target.files[0]));
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-10">
                    <div className="row">
                      <div
                        className={`form-group ${canvasAddFullScreen ? "col-md-6" : "col-md-4"} text-left mb-4`}
                      >
                        <label htmlFor="add_full_name">
                          Full Name:{" "}
                          <span className="text-danger">
                            {showFullNameError ? "Name is required" : ""}
                          </span>
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          id="add_full_name"
                          placeholder="Enter Full Name"
                          value={fullName}
                          onChange={(e) => {
                            setFullName(e.target.value);
                            setShowFullNameError(false);
                            setShowValidationError(false);
                          }}
                          onBlur={(e) =>
                            setShowFullNameError(e.target.value === "")
                          }
                        />
                      </div>
                      <div
                        className={`form-group ${canvasAddFullScreen ? "col-md-6" : "col-md-4"} text-left mb-4`}
                      >
                        <label htmlFor="add_username">
                          Username:
                          <span className="text-danger">
                            {showUsernameError
                              ? "Username is required"
                              : showUserNameExist
                                ? " Username already exists"
                                : ""}
                          </span>
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          id="add_username"
                          placeholder="Enter Username"
                          value={userName}
                          onChange={(e) => {
                            setUserName(e.target.value);
                            setShowUsernameError(false);
                            setShowUserNameExist(false);
                            setShowValidationError(false);
                          }}
                          onBlur={(e) => {
                            const val = e.target.value;
                            setShowUsernameError(!val);
                            if (val && checkIfUsernameExist(val))
                              setShowUserNameExist(true);
                          }}
                        />
                      </div>
                      <div
                        className={`form-group ${canvasAddFullScreen ? "col-md-6" : "col-md-4"} text-left mb-4`}
                      >
                        <label htmlFor="add_mobile">
                          Mobile:
                          <span className="text-danger">
                            {showMobileError
                              ? "Valid number required"
                              : showMobileExist
                                ? " Mobile already registered"
                                : ""}
                          </span>
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          id="add_mobile"
                          placeholder="Enter Mobile"
                          value={mobile}
                          onChange={(e) => {
                            setMobile(e.target.value);
                            setShowMobileError(false);
                            setShowMobileExist(false);
                            setShowValidationError(false);
                          }}
                          onBlur={(e) => {
                            const val = e.target.value;
                            setShowMobileError(!val || !isNumeric(val));
                            if (
                              val &&
                              isNumeric(val) &&
                              checkIfMobileExist(val)
                            )
                              setShowMobileExist(true);
                          }}
                        />
                      </div>
                      <div
                        className={`form-group ${canvasAddFullScreen ? "col-md-6" : "col-md-4"} text-left mb-4`}
                      >
                        <label htmlFor="add_email">
                          Email:
                          <span className="text-danger">
                            {showEmailError
                              ? "Valid email required"
                              : showEmailExist
                                ? " Email already registered"
                                : ""}
                          </span>
                        </label>
                        <input
                          type="email"
                          className="form-control form-control-sm"
                          id="add_email"
                          placeholder="Enter Email"
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                            setShowEmailError(false);
                            setShowEmailExist(false);
                            setShowValidationError(false);
                          }}
                          onBlur={(e) => {
                            const val = e.target.value;
                            setShowEmailError(!val || !validateEmail(val));
                            if (
                              val &&
                              validateEmail(val) &&
                              checkIfEmailExist(val)
                            )
                              setShowEmailExist(true);
                          }}
                        />
                      </div>
                      <div
                        className={`form-group ${canvasAddFullScreen ? "col-md-6" : "col-md-4"} text-left mb-4`}
                      >
                        <label htmlFor="add_password">Password:</label>
                        <input
                          type="password"
                          className="form-control form-control-sm"
                          id="add_password"
                          placeholder="Auto-generated"
                          disabled
                        />
                      </div>
                      <div
                        className={`form-group ${canvasAddFullScreen ? "col-md-6" : "col-md-4"} text-left mb-4`}
                      >
                        <label htmlFor="add_confirm_password">
                          Confirm Password:{" "}
                          <span className="text-danger">
                            {showConfirmPasswordError
                              ? "Password not matching"
                              : ""}
                          </span>
                        </label>
                        <input
                          type="password"
                          className="form-control form-control-sm"
                          id="add_confirm_password"
                          placeholder="Auto-generated"
                          disabled
                        />
                      </div>
                      <div
                        className={`form-group ${canvasAddFullScreen ? "col-md-6" : "col-md-4"} text-left mb-4`}
                      >
                        <label htmlFor="add_user_role">Role:</label>
                        <Select
                          options={rolesList}
                          id="add_user_role"
                          onChange={selectedUserRoles}
                          maxMenuHeight={canvasAddFullScreen ? 1000 : 200}
                          value={currentSelectedRoles}
                          styles={smallFormSelectCustomStyles}
                          isMulti
                          isClearable
                        />
                      </div>
                      <div
                        className={`form-group ${canvasAddFullScreen ? "col-md-6" : "col-md-4"} text-left mb-4`}
                      >
                        <label htmlFor="add_user_port">Port:</label>
                        <Select
                          options={portsList}
                          id="add_user_port"
                          onChange={selectedUserLocations}
                          maxMenuHeight={canvasAddFullScreen ? 1000 : 200}
                          value={currentSelectedPorts}
                          styles={smallFormSelectCustomStyles}
                          isMulti
                          isClearable
                        />
                        {showDepot && (
                          <>
                            <label htmlFor="add_user_depot" className="mt-4">
                              Depot:
                            </label>
                            <Select
                              options={depotList}
                              id="add_user_depot"
                              onChange={selectedUserDepot}
                              maxMenuHeight={canvasAddFullScreen ? 1000 : 200}
                              value={currentSelectedDepots}
                              styles={smallFormSelectCustomStyles}
                              isMulti
                              isClearable
                            />
                          </>
                        )}
                      </div>
                      <div
                        className={`form-group ${canvasAddFullScreen ? "col-md-6" : "col-md-4"} text-left mb-4`}
                      >
                        <label htmlFor="add_is_admin">Is Admin:</label>
                        <select
                          className="form-select form-select-sm"
                          id="add_is_admin"
                          value={isAdmin}
                          onChange={(e) => setIsAdmin(e.target.value)}
                        >
                          <option value="YES">YES</option>
                          <option value="NO">NO</option>
                        </select>
                        <label htmlFor="add_is_employee" className="mt-4">
                          Is Employee:
                        </label>
                        <select
                          className="form-select form-select-sm"
                          id="add_is_employee"
                          value={isEmployee}
                          onChange={(e) => setIsEmployee(e.target.value)}
                        >
                          <option value="YES">YES</option>
                          <option value="NO">NO</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          )}

          {/* Customer Tab */}
          {showUserCustomerDetails && (
            <div style={{ fontSize: 13 }}>
              <div className="row">
                <div
                  className={`form-group ${canvasAddFullScreen ? "col-md-6" : "col-md-6"} text-left mb-4`}
                >
                  <label htmlFor="add_user_customer">Customer:</label>
                  <Select
                    options={customerList}
                    id="add_user_customer"
                    onChange={selectedUserCustomer}
                    maxMenuHeight={canvasAddFullScreen ? 1000 : 200}
                    isMulti
                    isClearable
                  />
                </div>
                <div
                  className={`form-group ${canvasAddFullScreen ? "col-md-6" : "col-md-6"} text-left mb-4`}
                >
                  <label htmlFor="add_user_customer_branch">Branch:</label>
                  <Select
                    options={customerBranchList}
                    id="add_user_customer_branch"
                    onChange={selectedUserCustomerBranch}
                    maxMenuHeight={canvasAddFullScreen ? 1000 : 200}
                    isMulti
                    isClearable
                  />
                </div>
              </div>
            </div>
          )}

          {/* Agent Tab */}
          {showUserAgentDetails && (
            <div style={{ fontSize: 13 }}>
              <div className="row">
                <div
                  className={`form-group ${canvasAddFullScreen ? "col-md-12" : "col-md-12"} text-left mb-4`}
                >
                  <label htmlFor="add_user_agent">Agent:</label>
                  <Select
                    options={userAgentList}
                    id="add_user_agent"
                    onChange={selectedUserAgent}
                    maxMenuHeight={canvasAddFullScreen ? 1000 : 200}
                    isMulti
                    isClearable
                  />
                </div>
              </div>
            </div>
          )}

          <div className="canvas-btn-row mt-4">
            <Button
              type="submit"
              form="add-user-form"
              className="btn btn-inox-green border-0 canvas-button"
              disabled={hasAnyAddError() || showAddLoader}
            >
              {showAddLoader ? (
                <Spinner
                  className="mx-5 text-white"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                <>
                  <i className="fa fa-plus"></i>{" "}
                  <span className="mx-2">Add</span>
                </>
              )}
            </Button>

            {(hasAnyAddError() || showValidationError) && (
              <div className="error-tooltip-wrapper">
                <Button
                  style={{
                    backgroundColor: "#C21E22",
                    border: "#f82e2e",
                  }}
                  title="Show Errors"
                  className="mx-2"
                  onClick={handleCheckValidationClick}
                  onMouseLeave={() => setIsValidationErrorVisible(false)}
                >
                  <i className="fa fa-exclamation"></i>
                </Button>
                {isValidationErrorVisible && (
                  <div className="validation-error-tooltip">
                    <ul className="mb-0 px-4">
                      {buildAddErrorMessages().map((error, index) => (
                        <li key={index} className="text-left small pb-0">
                          {error}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserMaster;
